export default __webpack_public_path__ + "static/media/logomin.732f4391.svg";